export const handleError = (err) => {
    return {...err?.error, error: err?.error || err?.data, code: err?.status || 400}
}

export const getApiErrorMessage = (errorPayload) => {
    if (!errorPayload) {
        return "Unknown error, please try again later.";
    }

    if (typeof errorPayload === "string") {
        return errorPayload;
    }

    const apiError = errorPayload?.error ?? errorPayload;

    if (typeof apiError === "string") {
        return apiError;
    }

    if (apiError?.message) {
        return String(apiError.message);
    }

    if (errorPayload?.message) {
        return String(errorPayload.message);
    }

    if (errorPayload?.code) {
        const detail =
            (typeof errorPayload?.error === "string" && errorPayload.error) ||
            errorPayload?.error?.message ||
            errorPayload?.statusText ||
            "";
        if (detail) {
            return String(detail);
        }
        return `Request failed (${errorPayload.code}). No error details from server.`;
    }

    return "Unknown error, please try again later.";
}